import { useMemo } from 'react';

type Entry = {
  caregiverId?: string | null;
};

export const useHasAtLeastThreeCaregivers = (data: Entry[]): boolean => {
  return useMemo(() => {
    const caregiverCount = data.filter(
      (item) => item.caregiverId !== null
    ).length;
    return caregiverCount >= 3;
  }, [data]);
};
